<template>
    <div class="page-menu-block">
        <div role="button" title="Søk" class="iconic search-btn" @click="openSearch()">
            <span>Søk</span>
            <span class="icon" v-html="searchIcon()" />
        </div>
        <div role="button" title="Meny" @click="openMenu()" class="iconic menu-btn">
            <span>Meny</span>
            <span class="icon" v-html="menuIcon()" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { search, menu } from '@/components/../icons';


export default {
    name: 'page-menu',
    props: {
        // in %
        
    },
    methods:{
        ...mapMutations([
            'SEARCH_MODAL_CHANGE_STATE',
            'MENU_OPEN_CHANGE_STATE'
        ]),
        openSearch(){
            this.SEARCH_MODAL_CHANGE_STATE()
        },
        searchIcon(){
            return search('#005782')
        },
        menuIcon(){
            return menu('#005782')
        },
        openMenu(){
            this.MENU_OPEN_CHANGE_STATE()
        }
    },
    computed:{
        ...mapGetters([
            'mainNaviIsOpen',
            'searchModalOpen'
        ]),
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.page-menu-block{
    color: $darkLight;
    display: flex;
    .search-btn{
        margin-right: 25px;
        cursor: pointer;
    }
    .menu-btn{
        cursor: pointer;
    }
    .iconic{
        font-weight: 600;
        display: flex;
        align-items: center;
        .icon{
            margin-left: 11px;
        }
    }
}
</style>